import api from "./api";

class Splitwise {
  setToken(token) {
    this.token = token;
  }
  getAuthLink() {
    return api.getBaseUrl() + "splitwiseOauth";
  }
  getCurrentUser() {
    let headers = { "Content-Type": "application/json" };
    if (this.token) headers["Authorization"] = `Bearer ${this.token}`;
    return fetch(api.getBaseUrl() + `proxy?method=get_current_user`, {
      method: "get",
      headers,
    }).then((response) => response.json());
  }
  getFriends() {
    return fetch(api.getBaseUrl() + "get_friends");
  }
}

export default new Splitwise();
